import { useMemo } from 'react';
import { Paper, Box, Typography, Divider } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import { chartOptions, chartLineDataStyled } from '@/utils/charts';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

type TrendDistributionComponentProps = {
  title: string;
  height?: string;
  labels: string[];
  answersAmount: number[];
  children?: React.ReactNode;
};

const TrendDistribution = function ({
  title,
  height,
  labels,
  answersAmount,
  children,
}: TrendDistributionComponentProps): JSX.Element {
  const theme = useTheme();

  const options = useMemo(() => chartOptions(), []);

  const barData = useMemo(
    () =>
      chartLineDataStyled({
        labels,
        data: answersAmount,
        theme,
        tooltipLabel: 'Answer amount',
      }),
    [labels, answersAmount, theme]
  );

  return (
    <Paper variant="outlined" data-testid="trend-distribution">
      <Typography variant="h6" fontWeight={600} color="primary" paddingX={2} paddingY={1}>
        {title}
      </Typography>
      <Divider />
      <Box padding={2}>
        <Bar options={options} data={barData} height={height} />
        {children}
      </Box>
    </Paper>
  );
};

export default TrendDistribution;
